{
	"title": "Quizzes",
	"list": {
		"title": "All quizzes",
		"subtitle": "{count, plural, one {# quiz} other {# quizzes}}",
		"empty": "No quizzes yet",
		"emptyDescription": "Generate a quiz from a material or by exam — AI will pick the right types and difficulty.",
		"create": "Generate",
		"createEmpty": "Create empty",
		"createEmptyAction": "Create quiz",
		"createEmptyTitle": "Create empty quiz",
		"errorTitle": "Couldn't load quizzes",
		"errorDescription": "Check your connection and retry.",
		"retry": "Retry",
		"averageScore": "avg score {percent}%",
		"search": "Search quizzes...",
		"filterMaterial": "Material",
		"filterPreset": "Exam",
		"filterSort": "Sort",
		"sortByUpdated": "By date",
		"sortByName": "Alphabetical",
		"sortByScore": "By score",
		"viewGrid": "Grid",
		"viewList": "List",
		"showMore": "Show more",
		"filters": "Filters",
		"filtersTitle": "Filters",
		"delete": "Delete",
		"deletedToast": "Moved to trash",
		"play": "Take",
		"start": "Start",
		"continue": "Continue",
		"questionsCount": "{count, plural, one {# question} other {# questions}}",
		"attemptsCount": "{count, plural, one {# attempt} other {# attempts}}",
		"lastScore": "last {percent}%",
		"fromMaterial": "From material “{name}”",
		"fromChat": "From chat “{name}”",
		"averageBadge": "avg {percent}%",
		"generationProgress": "Generating — {percent}%",
		"stage": "stage: {stage}"
	},
	"edit": {
		"title": "Quiz editor",
		"backToList": "Back to list",
		"metadata": "Metadata",
		"questions": "Questions",
		"saveChanges": "Save",
		"addQuestion": "Add question",
		"deleteQuestion": "Delete question",
		"editQuestion": "Edit",
		"questionText": "Question text",
		"correctAnswer": "Correct answer",
		"explanation": "Explanation",
		"topic": "Topic",
		"difficulty": "Difficulty",
		"difficultyEasy": "Easy",
		"difficultyMedium": "Medium",
		"difficultyHard": "Hard",
		"addOption": "Add option",
		"removeOption": "Remove",
		"nameLabel": "Quiz name",
		"descriptionLabel": "Description",
		"timeLimitLabel": "Time limit (min), 0 = unlimited",
		"passingScoreLabel": "Passing score (%)",
		"examPresetLabel": "Exam",
		"noQuestions": "No questions yet. Add the first one.",
		"saved": "Saved",
		"generating": "Generating…",
		"generatingTitle": "AI is generating questions…",
		"generatingHint": "Usually takes 20–40 seconds. The page will refresh automatically.",
		"generationFailedTitle": "Couldn't generate the test",
		"generationFailedHint": "Try generating again or add questions manually.",
		"deleteConfirm": "Delete this question?",
		"deleteTitle": "Delete question?",
		"deleteDescription": "This action cannot be undone. The question will be removed from the test.",
		"deleteAction": "Delete",
		"deleteCancel": "Cancel"
	},
	"questionTypes": {
		"single": "Single answer",
		"multiple": "Multiple answers",
		"true-false": "True / False",
		"short-answer": "Short answer",
		"fill-blank": "Fill in the blank",
		"free-answer": "Free-form answer",
		"multi-layered-passage": "Multi-layered passage",
		"multipleChoice": "Multiple choice",
		"multipleAnswer": "Multiple answer",
		"trueFalse": "True / False",
		"shortAnswer": "Short answer",
		"essay": "Essay",
		"matching": "Matching",
		"multiLayeredPassage": "Multi-layered passage"
	},
	"take": {
		"exit": "Exit",
		"exitConfirmTitle": "Exit quiz?",
		"exitConfirmDescription": "Your progress is auto-saved. You can resume from this point.",
		"exitConfirm": "Exit",
		"cancel": "Cancel",
		"progress": "{current} of {total}",
		"next": "Next",
		"previous": "Back",
		"submit": "Submit",
		"submitError": "Couldn't submit answers",
		"submitOfflineTitle": "No connection — can't grade yet",
		"submitOfflineDescription": "Your answers are saved on this device. Submit again once you're back online.",
		"submitConfirmTitle": "Submit quiz?",
		"submitConfirmDescription": "You won't be able to change answers after submission.",
		"loadingTest": "Loading quiz…",
		"loadFailedTitle": "Couldn't start the quiz",
		"loadFailedDescription": "Check your connection and try again.",
		"offlineTitle": "Quiz isn’t available offline",
		"offlineDescription": "This quiz isn’t synced locally yet, or has no questions. Connect once to load it — then you can take it offline.",
		"retry": "Retry",
		"retrying": "Reconnecting…",
		"paywallTitle": "Plus required",
		"paywallDescription": "You've hit the free quiz limit.",
		"paywallCta": "Upgrade to Plus",
		"timeUp": "Time's up",
		"timeUpDescription": "Your answers have been saved automatically.",
		"viewResults": "View results",
		"selectAnswer": "Pick one",
		"selectAnswers": "Pick all that apply",
		"typeAnswer": "Type your answer",
		"writeAnswer": "Write your answer",
		"fillBlanks": "Fill in the blanks",
		"charCount": "{used} / {max}",
		"wordCount": "{count, plural, one {# word} other {# words}}",
		"subQuestion": "Sub-question {idx} of {total}",
		"gradingTitle": "Grading your answers…",
		"gradingDescription": "AI is grading free-form answers. This takes under a minute.",
		"dontKnow": "I don't know",
		"selectMultiple": "Select one or more options",
		"trueOption": "True",
		"falseOption": "False",
		"correctTitle": "Correct!",
		"incorrectTitle": "Keep practicing",
		"partialTitle": "Partially correct",
		"pendingReviewTitle": "Answer under review",
		"checkingTitle": "Checking your answer…",
		"aiFeedbackTitle": "AI feedback",
		"gradeDeferredNote": "Couldn't check it right now — AI will grade this answer after you finish the test.",
		"explanationTitle": "Explanation",
		"navigatorTitle": "Questions",
		"navigatorOpen": "All questions",
		"navigatorAnswered": "Answered",
		"navigatorCurrent": "Current",
		"navigatorUnanswered": "Unanswered",
		"jumpToQuestion": "Jump to question {number}",
		"questionLabel": "Question {number}",
		"timerLabel": "Time left",
		"finish": "Finish quiz",
		"finishHint": "All questions completed",
		"hintChoose": "select",
		"hintConfidence": "confidence",
		"hintNext": "next",
		"hintAnswer": "answer",
		"hintExit": "exit",
		"questionOfTotal": "Question {number} of {total}",
		"limitTitle": "Quiz limit reached",
		"limitDescription": "You can't start new quizzes right now. Your completed quizzes stay available."
	},
	"confidence": {
		"title": "How confident are you?",
		"not-confident": "Not sure",
		"unsure": "Somewhat",
		"confident": "Confident",
		"low": "Not sure",
		"medium": "Somewhat",
		"high": "Confident",
		"veryLow": "Not sure"
	},
	"results": {
		"title": "Results",
		"matrix": {
			"title": "Confidence × Correctness",
			"subtitle": "Find critical gaps and lucky guesses at a glance",
			"axis": {
				"correct": "Correct",
				"wrong": "Wrong"
			},
			"cell": {
				"mastery": "Mastered",
				"critical": "Critical gap",
				"softMastery": "Likely mastered",
				"expected": "Expected",
				"lucky": "Lucky guess",
				"acknowledged": "Acknowledged gap"
			},
			"drillDown": "{count, plural, one {# question} other {# questions}}",
			"yourAnswer": "Your answer",
			"empty": "No questions in this category"
		},
		"score": "{correct} of {total}",
		"percentage": "{percent}%",
		"passed": "Passed",
		"failed": "Failed",
		"reviewAnswers": "Review answers",
		"retake": "Retake",
		"backToTest": "Back to quizzes",
		"backToTopic": "Back to the topic",
		"retry": "Retry",
		"duration": "Time taken: {time}",
		"breakdownTitle": "Topic breakdown",
		"topicHeader": "Topic",
		"totalHeader": "Total",
		"correctHeader": "Correct",
		"accuracyHeader": "Accuracy",
		"weakHeader": "Confident & wrong",
		"questionsTitle": "Questions",
		"correct": "Correct",
		"partial": "Partially correct",
		"wrong": "Wrong",
		"skipped": "Skipped",
		"yourAnswer": "Your answer",
		"correctAnswer": "Correct answer",
		"explanation": "Explanation",
		"aiGraded": "AI-graded",
		"aiScore": "AI score: {score}",
		"aiFeedback": "AI feedback",
		"dispute": "Dispute",
		"weakSpotsBanner": "Weak spots detected — review recommendations",
		"viewWeakSpots": "Open weak spots",
		"scoreLabel": "Score",
		"correctOf": "{correct} of {total} correct",
		"nextStepsTitle": "What's next",
		"nextStepRetake": "Retake the quiz",
		"nextStepRetakeDesc": "Reinforce the material — try again with the same questions",
		"nextStepWeakSpots": "Review weak spots",
		"nextStepWeakSpotsDesc": "AI found topics with gaps — make flashcards and quizzes for them",
		"nextStepReview": "Re-read the material",
		"nextStepReviewDesc": "Go back to the note and close gaps before your next attempt",
		"nextStepDone": "Great result",
		"nextStepDoneDesc": "You passed confidently — move on to the next topic",
		"questionFilterAll": "All",
		"questionFilterWrong": "Mistakes",
		"questionFilterFlagged": "Flagged",
		"questionsCountLabel": "{count, plural, one {# question} other {# questions}}",
		"noQuestionsInFilter": "No questions in this category",
		"pendingGrading": "Awaiting AI grading"
	},
	"generate": {
		"title": "Generate quiz",
		"subtitle": "AI will create questions from a material, topic, or exam",
		"sourceMaterial": "From material",
		"sourceTopic": "From topic",
		"sourcePreset": "From exam preset",
		"materialPlaceholder": "Pick a material",
		"topicPlaceholder": "e.g. mitosis vs meiosis",
		"countLabel": "Question count: {count}",
		"difficultyLabel": "Difficulty",
		"difficultyMixed": "Mixed",
		"typesLabel": "Question types",
		"generate": "Generate",
		"cancel": "Cancel",
		"queued": "Quiz queued — you'll get a notification when it's ready"
	},
	"preset": {
		"title": "Pick an exam",
		"search": "Search presets...",
		"groupRU": "Russia",
		"groupUS": "USA",
		"groupUK": "UK",
		"groupInternational": "International",
		"groupOther": "Other",
		"select": "Select",
		"empty": "Nothing found"
	},
	"resume": {
		"title": "Resume quiz?",
		"description": "You have an unfinished attempt from {date}. Resume where you left off, or start over?",
		"continue": "Resume",
		"restart": "Start over"
	},
	"dispute": {
		"title": "Dispute grade",
		"description": "Tell us why you think the grade is unfair. AI will re-grade with your arguments in mind.",
		"reasonLabel": "Reason",
		"reasonPlaceholder": "e.g. my answer covers the definition fully but AI didn't account for synonyms",
		"submit": "Submit",
		"cancel": "Cancel",
		"submitted": "Dispute submitted"
	},
	"examPresets": {
		"title": "Exam presets",
		"custom": "Custom",
		"none": "No exam"
	},
	"presets": {
		"ege-math-base": "EGE Math (basic)",
		"ege-math-profile": "EGE Math (profile)",
		"ege-physics": "EGE Physics",
		"ege-chemistry": "EGE Chemistry",
		"ege-biology": "EGE Biology",
		"ege-russian": "EGE Russian",
		"ege-english": "EGE English",
		"ege-history": "EGE History",
		"ege-social-studies": "EGE Social Studies",
		"ege-literature": "EGE Literature",
		"ege-informatics": "EGE Informatics",
		"oge-math": "OGE Math",
		"oge-russian": "OGE Russian",
		"oge-english": "OGE English",
		"vpr-grade-4": "VPR Grade 4",
		"vpr-grade-5": "VPR Grade 5",
		"vpr-grade-6": "VPR Grade 6",
		"vpr-grade-7": "VPR Grade 7",
		"vpr-grade-8": "VPR Grade 8",
		"vpr-grade-11": "VPR Grade 11",
		"sat-math": "SAT Math",
		"sat-evidence-based-reading": "SAT Reading",
		"ap-calculus": "AP Calculus",
		"ap-physics": "AP Physics",
		"ap-chemistry": "AP Chemistry",
		"ap-biology": "AP Biology",
		"ap-history": "AP History",
		"mcat": "MCAT",
		"usmle-step-1": "USMLE Step 1",
		"usmle-step-2": "USMLE Step 2",
		"nclex": "NCLEX",
		"gre": "GRE",
		"gmat": "GMAT",
		"lsat": "LSAT",
		"gcse-math": "GCSE Math",
		"gcse-english": "GCSE English",
		"a-levels-math": "A-Levels Math",
		"a-levels-physics": "A-Levels Physics",
		"ielts-listening": "IELTS Listening",
		"ielts-reading": "IELTS Reading",
		"ielts-writing": "IELTS Writing",
		"ielts-speaking": "IELTS Speaking",
		"toefl-reading": "TOEFL Reading",
		"toefl-listening": "TOEFL Listening",
		"toefl-writing": "TOEFL Writing",
		"toefl-speaking": "TOEFL Speaking",
		"none": "No exam",
		"custom": "Custom format"
	},
	"intro": {
		"title": "What a test gives beyond a score",
		"body": "Along with the result comes a breakdown by topic: where you were confidently wrong and where you guessed. Weak spots build themselves from it.",
		"bullets": [
			"Seven question types, open-ended answers included",
			"You mark confidence — a confident mistake weighs more",
			"An attempt can be paused and resumed where you left off"
		]
	}
}
